import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('cart-slideout', {
  template: require('./template.html'),
  // TODO this will only be a styles edit, not page?
  // TODO slide out styler should always be open?
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
      'activeDroplet',
      'revertTriggered',
    ]),
    getWidth() {
      let width = '100%';
      if (this.viewport === 'mobile') {
        width = '600px';
      }
      if (this.viewport === 'tablet') {
        width = '992px';
      }
      return width;
    },
  },
  name: 'cart-slideout',
  data() {
    return {
      step: 1,
    };
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/cart-slideout/index.js